import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface ViewerTab {
  id: string;
  label: string;
}

interface ViewerStat {
  label: string;
  value: string;
}

@Component({
  selector: 'app-checkout-page',
  templateUrl: './checkout-page.component.html',
  styleUrls: ['./checkout-page.component.scss']
})
export class CheckoutPageComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  pageTitle = 'NIRF';
  pageSubtitle =
    'National Institutional Ranking Framework related institutional document and reference details.';

  admissionNotice =
    'Admissions open for 2026 : B.E (CIVIL), B.E (CSE), B.E (CSE - AI & ML), B.E (CSE - CS), B.E (ECE), B.E (EEE), B.E (MECH), MBA, M.E (CSE), M.E (Embedded System Technologies), M.E (Thermal Engineering).';

  tabs: ViewerTab[] = [
    { id: 'tab1', label: 'NIRF' }
  ];

  heroStats: ViewerStat[] = [
    { label: 'Category', value: 'Institution Document' },
    { label: 'Section', value: 'NIRF' },
    { label: 'Access', value: 'Embedded View' },
    { label: 'Purpose', value: 'Reference' }
  ];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'NIRF';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tabId: string): void {
    this.selectedTab = tabId;
  }

  ngOnInit(): void {}
}